import React from 'react'
import enterpriseLoader from "../../../Assets/Images/cinderbuild-enterprise-loader.gif"


const HorizontalLoader = () => {
    return (<div className='w-100 text-center horizontaLoader'><img src={enterpriseLoader} style={{width: "100px"}}></img></div>)
}

export default HorizontalLoader
